const RequiredMark = () => {
    return <span className="text-danger pl-1 text-xs mt-1">&#42;</span>;
};

export default RequiredMark;
